var exports = {
  "S": "xe533113f--38e0a4--image",
};

module.exports = exports;
